<!-- eslint-disable @angular-eslint/template/elements-content -->

<div class="table-wrapper">
  <div class="adjustable-table-container">
    <as-split [useTransition]="true" unit="percent" [gutterSize]="10">
      <as-split-area [size]="50" [visible]="keepLeft">
        @if (isDataFetched) {
          <div class="column-split">
            @if (dataSource && dataSource.length > 0) {
              <div class="row">
                <form>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-5">
                        <p class="title-name">All Project</p>
                      </div>
                      <div class="col-7 table-col">
                        <button mat-button class="collapse-btn" (click)="keepRight = !keepRight">
                          @if (!keepRight) {
                            <mat-icon class="white-icon">arrow_back</mat-icon>
                          }
                          @if (keepRight) {
                            <mat-icon class="white-icon">arrow_forward</mat-icon>
                          }
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <mat-checkbox
                        [(ngModel)]="selectAllChecked"
                        (change)="onSelectAllChange()"
                        name="selectAllProjects"
                        [ngModelOptions]="{ standalone: true }"
                        color="primary"
                        class="checkbox-left"
                        [indeterminate]="shouldShowIndeterminateState()">
                        Select All Projects
                      </mat-checkbox>
                    </div>
                    <div class="combinetable-wrapper">
                      <mat-accordion>
                        @for (data of dataSource; track data) {
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <mat-panel-title (click)="$event.stopPropagation()">
                                <mat-checkbox
                                  [(ngModel)]="data.isChecked"
                                  color="primary"
                                  [ngModelOptions]="{ standalone: true }"
                                  (change)="onCheckboxChange(data)">
                                </mat-checkbox>
                                Project: {{ data.projectNumber }} - {{ data.projectName }} - {{ data.sampleCount }} Samples
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <!-- Parent Table -->
                            <div class="parent-table">
                              <table mat-table [dataSource]="[data]" class="mat-elevation-z2">
                                <!-- Project Number Column -->
                                <ng-container matColumnDef="projectNumber">
                                  <th mat-header-cell *matHeaderCellDef>Project #</th>
                                  <td mat-cell *matCellDef="let element">{{ element.projectNumber }}</td>
                                </ng-container>
                                <!-- Project Name Column -->
                                <ng-container matColumnDef="projectName">
                                  <th mat-header-cell *matHeaderCellDef>Project Name</th>
                                  <td mat-cell *matCellDef="let element">{{ element.projectName }}</td>
                                </ng-container>
                                <!-- Soil Type Column -->
                                <ng-container matColumnDef="soilType">
                                  <th mat-header-cell *matHeaderCellDef>Material Type</th>
                                  <td mat-cell *matCellDef="let element">{{ element.soilType }}</td>
                                </ng-container>
                                <!-- Submitted Column -->
                                <ng-container matColumnDef="submitted">
                                  <th mat-header-cell *matHeaderCellDef>Submitted</th>
                                  <td mat-cell *matCellDef="let element">{{ element.submitted | date }}</td>
                                </ng-container>
                                <!-- Sample Received Date Column -->
                                <ng-container matColumnDef="sampleReceivedDate">
                                  <th mat-header-cell *matHeaderCellDef>Received</th>
                                  <td mat-cell *matCellDef="let element">{{ element.sampleReceivedDate | date }}</td>
                                </ng-container>
                                <!-- Due Date Column -->
                                <ng-container matColumnDef="dueDate">
                                  <th mat-header-cell *matHeaderCellDef>Due</th>
                                  <td mat-cell *matCellDef="let element">{{ element.dueDate | date }}</td>
                                </ng-container>
                                <!-- Status Column -->
                                <ng-container matColumnDef="status">
                                  <th mat-header-cell *matHeaderCellDef>Status</th>
                                  <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                                </ng-container>
                                <!-- Header and Rows -->
                                <tr mat-header-row *matHeaderRowDef="parentDisplayColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: parentDisplayColumns"></tr>
                              </table>
                            </div>
                            <!-- Native Soil -->
                            @if (soiltype === 'nativesoil') {
                              <div>
                                @if (data.nativeSoilSamples && data.nativeSoilSamples.length > 0) {
                                  <div>
                                    <div class="child-table">
                                      <table
                                        mat-table
                                        [dataSource]="data.nativeSoilSamples"
                                        class="mat-elevation-z8 sample-table">
                                        <!-- Define columns dynamically -->
                                        @for (col of headerColumns; track col) {
                                          <ng-container [matColumnDef]="col.name">
                                            <th mat-header-cell *matHeaderCellDef>
                                              @if (col.name !== 'sampleStatusTypeId') {
                                                <span>{{ col.displayName }}</span>
                                              }
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                              @if (col.name !== 'sampleStatusTypeId') {
                                                <!-- Render displayDepth if applicable -->
                                                @if (col.name === 'displayDepth' && element[col.name] !== null) {
                                                  <span>
                                                    {{ getDisplayDepth(element) }}
                                                  </span>
                                                }
                                                <!-- Render other columns -->
                                                @if (col.name !== 'displayDepth' && element[col.name] !== null) {
                                                  <span
                                                    [title]="col.format === 'truncate' && element[col.name] ? element[col.name] : ''"
                                                    [innerHTML]="(element[col.name] ? element[col.name] : '') | format : col.format">
                                                  </span>
                                                }
                                              }
                                            </td>
                                          </ng-container>
                                        }
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                      </table>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            <!-- Precast -->
                            @if (soiltype === 'precast') {
                              <div>
                                @if (data.preCastSamples && data.preCastSamples.length > 0) {
                                  <div>
                                    <div class="child-table">
                                      <table mat-table [dataSource]="data.preCastSamples" class="mat-elevation-z8 sample-table">
                                        <!-- Define columns dynamically -->
                                        @for (col of headerColumns; track col) {
                                          <ng-container [matColumnDef]="col.name">
                                            <th mat-header-cell *matHeaderCellDef>
                                              @if (col.name !== 'sampleStatusTypeId') {
                                                <span>{{ col.displayName }}</span>
                                              }
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                              @if (col.name !== 'sampleStatusTypeId') {
                                                <!-- Render displayDepth if applicable -->
                                                @if (col.name === 'displayDepth' && element[col.name] !== null) {
                                                  <span>
                                                    {{ getDisplayDepth(element) }}
                                                  </span>
                                                }
                                                <!-- Render other columns -->
                                                @if (col.name !== 'displayDepth' && element[col.name] !== null) {
                                                  <span
                                                    [title]="col.format === 'truncate' && element[col.name] ? element[col.name] : ''"
                                                    [innerHTML]="(element[col.name] ? element[col.name] : '') | format : col.format">
                                                  </span>
                                                }
                                              }
                                            </td>
                                          </ng-container>
                                        }
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                      </table>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                      </mat-accordion>
                    </div>
                  </div>
                </form>
              </div>
            } @else {
              @if (dataSource && dataSource.length === 0) {
                <section class="no-search-section">
                  <div class="search-result">No such records found</div>
                </section>
              }
            }
          </div>
        }
      </as-split-area>
      <as-split-area [size]="50" [visible]="keepRight">
        @if (isDataFetched) {
          <div class="column-split">
            @if (selectedProjects && selectedProjects.length > 0) {
              <div class="row">
                <form>
                  <div class="col-md-12 table-combine-title">
                    <div class="row">
                      <div class="col-5">
                        <p class="title-name">Combine Project</p>
                      </div>
                      <div class="col-7 table-col">
                        <button mat-button class="collapse-btn" (click)="keepLeft = !keepLeft">
                          @if (keepLeft) {
                            <mat-icon class="white-icon">arrow_back</mat-icon>
                          }
                          @if (!keepLeft) {
                            <mat-icon class="white-icon">arrow_forward</mat-icon>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="combinetable-wrapper">
                    <mat-accordion>
                      @for (data of selectedProjects; track data) {
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title (click)="$event.stopPropagation()">
                              <div class="cancel-icon">
                                <mat-icon class="cursor" matSuffix (click)="removeProject(data)"> close </mat-icon>
                              </div>
                              Project: {{ data.projectNumber }} - {{ data.projectName }} - {{ data.sampleCount }} Samples
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <!-- Parent Table -->
                          <div class="parent-table">
                            <table mat-table [dataSource]="[data]" class="mat-elevation-z2">
                              <!-- Project Number Column -->
                              <ng-container matColumnDef="projectNumber">
                                <th mat-header-cell *matHeaderCellDef>Project #</th>
                                <td mat-cell *matCellDef="let element">{{ element.projectNumber }}</td>
                              </ng-container>
                              <!-- Project Name Column -->
                              <ng-container matColumnDef="projectName">
                                <th mat-header-cell *matHeaderCellDef>Project Name</th>
                                <td mat-cell *matCellDef="let element">{{ element.projectName }}</td>
                              </ng-container>
                              <!-- Soil Type Column -->
                              <ng-container matColumnDef="soilType">
                                <th mat-header-cell *matHeaderCellDef>Material Type</th>
                                <td mat-cell *matCellDef="let element">{{ element.soilType }}</td>
                              </ng-container>
                              <!-- Submitted Column -->
                              <ng-container matColumnDef="submitted">
                                <th mat-header-cell *matHeaderCellDef>Submitted</th>
                                <td mat-cell *matCellDef="let element">{{ element.submitted | date }}</td>
                              </ng-container>
                              <!-- Sample Received Date Column -->
                              <ng-container matColumnDef="sampleReceivedDate">
                                <th mat-header-cell *matHeaderCellDef>Received</th>
                                <td mat-cell *matCellDef="let element">{{ element.sampleReceivedDate | date }}</td>
                              </ng-container>
                              <!-- Due Date Column -->
                              <ng-container matColumnDef="dueDate">
                                <th mat-header-cell *matHeaderCellDef>Due</th>
                                <td mat-cell *matCellDef="let element">{{ element.dueDate | date }}</td>
                              </ng-container>
                              <!-- Status Column -->
                              <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                              </ng-container>
                              <!-- Header and Rows -->
                              <tr mat-header-row *matHeaderRowDef="parentDisplayColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: parentDisplayColumns"></tr>
                            </table>
                          </div>
                          <!-- Native Soil -->
                          @if (soiltype === 'nativesoil') {
                            <div>
                              @if (data.nativeSoilSamples && data.nativeSoilSamples.length > 0) {
                                <div>
                                  <div class="child-table">
                                    <table mat-table [dataSource]="data.nativeSoilSamples" class="mat-elevation-z8 sample-table">
                                      <!-- Define columns dynamically -->
                                      @for (col of headerColumns; track col) {
                                        <ng-container [matColumnDef]="col.name">
                                          <th mat-header-cell *matHeaderCellDef>
                                            @if (col.name !== 'sampleStatusTypeId') {
                                              <span>{{ col.displayName }}</span>
                                            }
                                          </th>
                                          <td mat-cell *matCellDef="let element">
                                            @if (col.name !== 'sampleStatusTypeId') {
                                              <!-- Render displayDepth if applicable -->
                                              @if (col.name === 'displayDepth' && element[col.name] !== null) {
                                                <span>
                                                  {{ getDisplayDepth(element) }}
                                                </span>
                                              }
                                              <!-- Render other columns -->
                                              @if (col.name !== 'displayDepth' && element[col.name] !== null) {
                                                <span
                                                  [title]="col.format === 'truncate' && element[col.name] ? element[col.name] : ''"
                                                  [innerHTML]="(element[col.name] ? element[col.name] : '') | format : col.format">
                                                </span>
                                              }
                                            }
                                          </td>
                                        </ng-container>
                                      }
                                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                    </table>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          <!-- Precast -->
                          @if (soiltype === 'precast') {
                            <div>
                              @if (data.preCastSamples && data.preCastSamples.length > 0) {
                                <div>
                                  <div class="child-table">
                                    <table mat-table [dataSource]="data.preCastSamples" class="mat-elevation-z8 sample-table">
                                      <!-- Define columns dynamically -->
                                      @for (col of headerColumns; track col) {
                                        <ng-container [matColumnDef]="col.name">
                                          <th mat-header-cell *matHeaderCellDef>
                                            @if (col.name !== 'sampleStatusTypeId') {
                                              <span>{{ col.displayName }}</span>
                                            }
                                          </th>
                                          <td mat-cell *matCellDef="let element">
                                            @if (col.name !== 'sampleStatusTypeId') {
                                              <!-- Render displayDepth if applicable -->
                                              @if (col.name === 'displayDepth' && element[col.name] !== null) {
                                                <span>
                                                  {{ getDisplayDepth(element) }}
                                                </span>
                                              }
                                              <!-- Render other columns -->
                                              @if (col.name !== 'displayDepth' && element[col.name] !== null) {
                                                <span
                                                  [title]="col.format === 'truncate' && element[col.name] ? element[col.name] : ''"
                                                  [innerHTML]="(element[col.name] ? element[col.name] : '') | format : col.format">
                                                </span>
                                              }
                                            }
                                          </td>
                                        </ng-container>
                                      }
                                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                    </table>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </mat-expansion-panel>
                      }
                    </mat-accordion>
                  </div>
                </form>
              </div>
            } @else {
              @if (selectedProjects && selectedProjects.length === 0) {
                <section class="no-search-section">
                  <div class="search-result">No such records found</div>
                </section>
              }
            }
          </div>
        }
      </as-split-area>
    </as-split>
  </div>
</div>

<!-- <section class="no-search-section" *ngIf="dataSource && dataSource.length === 0">
<div class="search-result">No such records found</div>
</section> -->
<!-- Drop down project select-->
@if (selectedProjects && selectedProjects.length > 0) {
  <div class="project-wrapper">
    <div class="col-md-12">
      <div class="row">
        <div class="col-2 input-label">
          <mat-label class="mat-label" for="project"
            > Select the primary combine project:</mat-label
            > <a
            href="javascript:void(0)"
            #tooltip="matTooltip"
            alt="tooltip-information"
        matTooltip=" We need to create a new project for combine project report, out of the projects selected above, which project
        data can be used for the new project.">
            <img src="/assets/icons/Alert-grey.svg" alt="alert-grey-icon" />
          </a>
        </div>
        <div class="col-3 input-field">
          <mat-form-field appearance="outline" class="mat-form-field-width">
            <mat-select placeholder="Select the Project" (selectionChange)="onProjectSelected($event)">
              @for (project of selectedProjects; track project) {
                <mat-option [value]="project.id">
                  {{ project.projectNumber }} - {{ project.projectName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-7 table-col"></div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-2 input-label">
          <mat-label class="mat-label" for="project">New Project Number :</mat-label>
        </div>
        <div class="col-3 input-field">
          <mat-form-field appearance="outline" class="mat-form-field-width">
            <input matInput class="search-text" maxlength="50" (input)="onProjectNumberChange($event)" />
          </mat-form-field>
        </div>
        <div class="col-7 table-col"></div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-2 input-label">
          <mat-label class="mat-label" for="project">New Project Name :</mat-label>
        </div>
        <div class="col-3 input-field">
          <mat-form-field appearance="outline" class="mat-form-field-width">
            <input matInput class="search-text" maxlength="50" (input)="onProjectNameChange($event)" />
          </mat-form-field>
        </div>
        <div class="col-7 table-col"></div>
      </div>
    </div>
  </div>
}
<div class="spacer"></div>

@if (selectedProjects && selectedProjects.length > 0) {
  <div class="btn-wrapper">
    <div class="no-print btn-container btn-right">
      <button class="split-flag" mat-raised-button (click)="onCancel()">CANCEL</button>
      &nbsp;&nbsp;
      <button mat-raised-button color="primary" [disabled]="!showBtn || isSampleCountExceeded()" (click)="combine()">COMBINE</button>
    </div>
  </div>
}
